export * from "./remitos-motivo-dialog.component";



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remitos-motivo-dialog/index.ts